import { Route } from "react-router-dom";
import ReservationsDailyManifestReportScreen from "../../../container/Reservations/ReservationsDailyManifestReportScreen";
import CreateReservationsDailyManifestReport from "../../../container/Reservations/ReservationsDailyManifestReportScreen/CreateReservationsDailyManifestReport";
import { APP_URLS } from "../../../utils/constant";

const ReservationsDailyManifestReportRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RESERVATIONS_DAILYMANIFESTREPORT.HOME}
          element={
            <ReservationsDailyManifestReportScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RESERVATIONS_DAILYMANIFESTREPORT.CREATE}
          element={<CreateReservationsDailyManifestReport />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RESERVATIONS_DAILYMANIFESTREPORT.EDIT}
          element={<CreateReservationsDailyManifestReport isEdit={true} />}
        />
      )}
    </>
  );
};

export default ReservationsDailyManifestReportRoutes;
